
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myAccountMenu } from '@xt/client/dataSource/my/index'
import { EnumMyAccountMenu } from '@xt/client/enums/my'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'
import MyLayout from '../views/MyLayout/index.vue'

import MyAccountOrder from './views/Order/index.vue'
import MyAccountPacks from './views/Packs/index.vue'
import MyAccountExchange from './views/Exchange/index.vue'
import MyAccountBishan from './views/Bishan/index.vue'
import MyAccountCoin from './views/Coin/index.vue'

import type { UserInfo } from '@xt/client/entities/user/types'

@Observer
@Component({
  scrollToTop: true,
  components: {
    MyLayout,
    MyAccountOrder,
    MyAccountPacks,
    MyAccountExchange,
    MyAccountBishan,
    MyAccountCoin
  },
  async asyncData(ctx) {
    // 没有token 用户没登录
    if (!ctx.store.$storeUser.isLogin) {
      ctx.redirect('/')
      return { userInfo: null }
    }

    const userInfo: UserInfo | undefined = ctx.store.$storeUser.UserInfo || (await ctx.store.$storeUser.onUpdatingUserInfo())

    if (!userInfo) {
      // 异常
      ctx.redirect('/')
      return { userInfo: null }
    }

    return {
      userInfo
    }
  }
})
export default class MyAccountPage extends Vue {
  userInfo: UserInfo | null

  current: EnumMyAccountMenu = EnumMyAccountMenu.Order

  compMap: Record<EnumMyAccountMenu, string> = {
    [EnumMyAccountMenu.Order]: 'MyAccountOrder',
    [EnumMyAccountMenu.Bishan]: 'MyAccountBishan',
    [EnumMyAccountMenu.Coin]: 'MyAccountCoin',
    [EnumMyAccountMenu.Exchange]: 'MyAccountExchange',
    [EnumMyAccountMenu.Packs]: 'MyAccountPacks'
  }

  get menuKey() {
    return lodash.get(this.$route.query, 'menu', EnumMyAccountMenu.Order)
  }

  get menus() {
    return myAccountMenu
  }

  get PageStore() {
    return this.$store.$myV2.Account
  }

  handleChangeMenu(menu: EnumMyAccountMenu) {
    this.current = menu

    this.$router.replace({
      query: {
        menu
      }
    })

    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {
    this.current = this.menuKey as EnumMyAccountMenu
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
